(() => {
  "use strict";

  const roots = document.querySelectorAll("[data-af-clsnap]");
  if (!roots.length) return;

  const prefersReduced =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isMobile =
    window.matchMedia("(max-width: 599px)").matches;

  roots.forEach((root) => {
    if (root.dataset.afClsnapInit === "1") return;
    root.dataset.afClsnapInit = "1";

    const panels = Array.from(root.querySelectorAll("[data-af-clsnap-panel]"));
    if (!panels.length) return;

    // Mobile and reduced motion — reveal everything immediately, no jitter
    if (prefersReduced || isMobile) {
      panels.forEach((p) => p.classList.add("is-visible"));
      return;
    }

    // Desktop — staggered fade-in as cards enter viewport
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          let step = 0;
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            en.target.style.transitionDelay = step * 55 + "ms";
            en.target.classList.add("is-visible");
            setTimeout(
              () => (en.target.style.transitionDelay = ""),
              500 + step * 55
            );
            step++;
            io.unobserve(en.target);
          });
        },
        { threshold: 0.06, rootMargin: "0px 0px -24px 0px" }
      );

      panels.forEach((p) => io.observe(p));
    } else {
      panels.forEach((p) => p.classList.add("is-visible"));
    }
  });
})();